import { render, staticRenderFns } from "./Game-add.vue?vue&type=template&id=27aa2444&"
import script from "./Game-add.vue?vue&type=script&lang=js&"
export * from "./Game-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports